import { render, staticRenderFns } from "./ReportReception.vue?vue&type=template&id=7d74912c"
import script from "./ReportReception.vue?vue&type=script&lang=js"
export * from "./ReportReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports